import "./ChipWithIcon.scss"
export interface ChipWithIconProps {
  icon: string | undefined;
  text: string | undefined;
}

const ChipWithIcon: React.FunctionComponent<ChipWithIconProps> = ({
  icon,
  text,
}) => {
  return (
    <div className="chipContainer">
      <img src={icon} alt="icon" className="itemPropertyIcon" />
      <p className="itemProperty">{text}</p>
    </div>
  );
};

export default ChipWithIcon;
